import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { extendTheme, ChakraProvider, Box, Text } from '@chakra-ui/react';
import { buttonTheme } from './button.js';
import semanticTokens from './semantic.js';
import spacing from './spacing.js';
import fonts from './fonts.js';
import opacity from './opacity.js';
import shadows from './shadows.js';
import borderRadius from './borderRadius.js';
import { switchTheme } from './switch.js';
import { dividerTheme } from './divider.js';
import { avatarTheme } from './avatar.js';
import { modalTheme } from './modal.js';
import { cardTheme } from './card.js';
import { spinnerTheme } from './spinner.js';
import { drawerTheme } from './drawer.js';
import { badgeTheme } from './badge.js';
import { tagTheme } from './tag.js';
import { skeletonTheme } from './skeleton.js';
import { tooltipTheme } from './tooltip.js';
import { accordionTheme } from './accordion.js';
import { inputTheme } from './input.js';
import { formTheme } from './form.js';
import { numberInputTheme } from './numberInput.js';
import { textareaTheme } from './textarea.js';
import { tabsTheme } from './tabs.js';
import { checkboxTheme } from './checkbox.js';
import { radioTheme } from './radio.js';
import CloseIcon from '../icons/CloseIcon.js';

var theme = extendTheme({
    fonts: fonts,
    semanticTokens: semanticTokens,
    opacity: opacity,
    radii: borderRadius,
    shadows: shadows,
    components: {
        Button: buttonTheme,
        Switch: switchTheme,
        Divider: dividerTheme,
        Avatar: avatarTheme,
        Modal: modalTheme,
        Card: cardTheme,
        Loader: spinnerTheme,
        Drawer: drawerTheme,
        Badge: badgeTheme,
        Tooltip: tooltipTheme,
        Accordion: accordionTheme,
        Tag: tagTheme,
        Input: inputTheme,
        Form: formTheme,
        NumberInput: numberInputTheme,
        Textarea: textareaTheme,
        Tabs: tabsTheme,
        Checkbox: checkboxTheme,
        Radio: radioTheme,
        Skeleton: skeletonTheme,
    },
    space: spacing,
});
var statusColors = {
    info: "neutrals.900",
    warning: "warning.500",
    success: "neutrals.900",
    error: "error.800",
};
var ThemeProvider = function (_a) {
    var _b, _c, _d;
    var children = _a.children, toastDefaultOptions = _a.toastDefaultOptions;
    var defaultDuration = 1400;
    var defaultPosition = "bottom";
    var defaultIsClosable = true;
    return (React.createElement(ChakraProvider, { theme: theme, toastOptions: {
            defaultOptions: __assign(__assign({ duration: (_b = toastDefaultOptions === null || toastDefaultOptions === void 0 ? void 0 : toastDefaultOptions.duration) !== null && _b !== void 0 ? _b : defaultDuration, position: (_c = toastDefaultOptions === null || toastDefaultOptions === void 0 ? void 0 : toastDefaultOptions.position) !== null && _c !== void 0 ? _c : defaultPosition, isClosable: (_d = toastDefaultOptions === null || toastDefaultOptions === void 0 ? void 0 : toastDefaultOptions.isClosable) !== null && _d !== void 0 ? _d : defaultIsClosable }, toastDefaultOptions), { render: function (_a) {
                    var title = _a.title, isClosable = _a.isClosable, onClose = _a.onClose, status = _a.status;
                    return (React.createElement(Box, { color: "#FFF", bg: statusColors[status], borderRadius: 8, p: (toastDefaultOptions === null || toastDefaultOptions === void 0 ? void 0 : toastDefaultOptions.isMobile) ? '8px' : '16px', gap: "16px", display: "flex", width: "max-content", maxWidth: "90vw", position: "relative", left: "50%", transform: "translateX(-50%)", alignItems: "center", justifyContent: "center", minWidth: "240px" },
                        React.createElement(Text, { fontSize: (toastDefaultOptions === null || toastDefaultOptions === void 0 ? void 0 : toastDefaultOptions.isMobile) ? '12px' : '20px', fontStyle: "normal", fontWeight: "400", lineHeight: "24px", variant: "small", whiteSpace: "nowrap", textAlign: "center", flex: "1" }, title),
                        isClosable ? (React.createElement(CloseIcon, { onClick: onClose, height: "15px", width: "15px", color: "white", cursor: "pointer" })) : ("")));
                } }),
        } }, children));
};

export { ThemeProvider, theme };
//# sourceMappingURL=index.js.map
